import { BLOCK_TYPES } from '../blocks/types.js';
import { SERVICE_CATALOG, servicePath } from '../../navigation/serviceCatalog.js';

// Service Content — Long-Distance Transfer (FINAL service; golden pattern: PR #250-#255). Authored
// FRENCH content from existing Content-Platform blocks. Describes long-distance / intercity private
// chauffeur transport DEPARTING the Black Matte service area. Facts owner-ratified / inherent
// (long-distance transport, France) + the general verified set (chauffeur privé premium, Nantes/
// Loire-Atlantique, confort, discrétion, ponctualité, online booking, price-before-booking, 24/7,
// SAB area). NO long-distance marketing copy exists in the locales, so nothing route-specific is
// invented. Destinations are GENERIC ("partout en France") — NO named city/route, NO pricing.
// FORBIDDEN (NOT present): predefined routes / Paris-or-other city pricing, péage/carburant inclus,
// durée garantie, exact km limits, tourisme / visite / guide / chauffeur-guide, hôtel / nuit /
// plusieurs jours / overnight chauffeur, itinerary planning, concierge, luggage-handling,
// waiting-time, guaranteed/dedicated chauffeur, vehicle brand/model, exact prices, reviews/ratings/
// awards/certifications. Vehicles BRAND-NEUTRAL. CTA = book OR contact (/reserver + /contact).
// Mesh derived from the ratified catalogue.

const SLUG = 'long-distance-transfer';
const siblings = SERVICE_CATALOG
  .filter((s) => s.slug !== SLUG)
  .map((s) => ({ label: s.name, to: servicePath(s.slug) }));

export default {
  blocks: [
    {
      type: BLOCK_TYPES.HERO,
      kicker: 'Chauffeur privé premium',
      title: 'Chauffeur longue distance à Nantes',
      lead:
        'Un chauffeur privé pour vos trajets longue distance au départ de Nantes et de la Loire-Atlantique — confortable, discret et au prix connu à l’avance.',
    },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte assure vos trajets longue distance au départ de Nantes et de la Loire-Atlantique, partout en France, avec des véhicules haut de gamme et un service ponctuel et discret, réservable en ligne.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Pourquoi choisir un chauffeur pour vos longs trajets',
      body: [
        'Pour un trajet longue distance, voyager avec un chauffeur privé vous évite la fatigue de la conduite et la gestion de l’itinéraire. Vous profitez du temps de trajet pour vous reposer, travailler ou passer vos appels, confortablement installé.',
        'Vous voyagez à bord d’un véhicule haut de gamme, confortable et soigné, conduit par un chauffeur privé professionnel et discret. Le prix vous est communiqué avant la réservation, en toute transparence.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Un long trajet en toute sérénité',
      items: [
        { title: 'Confort', text: 'Un véhicule haut de gamme, spacieux et soigné, pour voyager détendu sur de longues distances.' },
        { title: 'Discrétion', text: 'Un service professionnel et confidentiel, propice au repos comme au travail.' },
        { title: 'Ponctualité', text: 'Une prise en charge à l’heure, à votre adresse de départ.' },
        { title: 'Réservation simple', text: 'Réservez en ligne en quelques minutes, avec un prix connu à l’avance.' },
      ],
    },
    {
      type: BLOCK_TYPES.STEPS,
      heading: 'Comment réserver votre trajet longue distance',
      steps: [
        { title: 'Indiquez votre trajet', text: 'Renseignez votre adresse de départ, votre destination, la date et l’heure.' },
        { title: 'Obtenez votre tarif', text: 'Votre prix est calculé et communiqué avant de confirmer la réservation.' },
        { title: 'Confirmez en ligne', text: 'Validez votre réservation en quelques minutes, directement en ligne.' },
        { title: 'Votre chauffeur vous conduit', text: 'Votre chauffeur vous prend en charge à l’heure et vous conduit à destination.' },
      ],
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Vos trajets longue distance au départ de la Loire-Atlantique',
      body: [
        'Au départ de Nantes, de la Loire-Atlantique et de sa région — Angers, Rennes, La Roche-sur-Yon — Black Matte vous conduit vers la destination de votre choix, partout en France, pour un rendez-vous, un déplacement professionnel ou un trajet personnel.',
        'Notre service est disponible 24h/24 et 7j/7, avec des chauffeurs privés professionnels et discrets, pour un trajet longue distance confortable et sans stress.',
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre trajet longue distance',
      text: 'Réservez votre chauffeur privé pour votre trajet longue distance, ou contactez-nous pour toute demande particulière.',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Nous contacter', to: '/contact' },
      ],
    },
    {
      type: BLOCK_TYPES.RELATED_CONTENT,
      heading: 'Autres prestations',
      links: siblings,
    },
  ],
};
